import { render, staticRenderFns } from "./EditWarehouse.vue?vue&type=template&id=f0b0f55c"
import script from "./EditWarehouse.vue?vue&type=script&lang=js"
export * from "./EditWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports